import { render, staticRenderFns } from "./editPayrollDetail.vue?vue&type=template&id=b98babc0&scoped=true&"
import script from "./editPayrollDetail.vue?vue&type=script&lang=js&"
export * from "./editPayrollDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98babc0",
  null
  
)

export default component.exports